export default {
    Metadata: {
        Name: "AddHours",
        Description: "Returns a date with the specified hours added.",
        Syntax: "AddHours(date, number)",
        Keywords: ['Date', 'Time'],
        Author: "DataVoke, Inc.",
    },
    execute(d, c) {
        d = app.dv.helpers.exprEng.expr.todate(d);
        if (d == null) {
            return null;
        }
        if (isNaN(c)) {
            return null;
        }
        var a = new Date(d);
        return a.addHours(c);
    },
};

